import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { errorMessage } from '../utils/errors';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function surfaceToPhoto(surface) {
  if (surface === 'beach') return 'photo-beach';
  if (surface === 'green') return 'photo-sunset';
  return 'photo-court';
}

const POSITIONS = [
  { value: '', label: 'Peu importe' },
  { value: 'passeur', label: 'Passeur' },
  { value: 'attaquant', label: 'Attaquant' },
];
const LEVELS = [
  { value: 'loisir', label: 'Loisir' },
  { value: 'departemental', label: 'Dép.' },
  { value: 'regional', label: 'Régio.' },
  { value: 'national', label: 'Nat.' },
  { value: 'pro', label: 'Pro' },
];
const BOOST_OPTIONS = [
  { value: 'standard', label: 'Standard', sublabel: 'Visible dans le fil Actu et l\'onglet Joueurs', badge: 'GRATUIT' },
  { value: 'boost', label: 'Urgent · épinglé', sublabel: 'Notifié aux joueurs proches qui jouent ce format', badge: 'BOOST' },
];

function SectionTitle({ children, right }) {
  return (
    <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between',
      padding: '0 20px', margin: '24px 0 10px' }}>
      <h3 style={{ fontSize: 13, fontWeight: 700, letterSpacing: '0.08em',
        textTransform: 'uppercase', color: 'var(--text-2)', margin: 0 }}>{children}</h3>
      {right && <span className="mono" style={{ fontSize: 11, color: 'var(--sun-2)' }}>{right}</span>}
    </div>
  );
}

export default function CreatePartnerSearch({ user }) {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const [myTournaments, setMyTournaments] = useState([]);
  const [selectedTournament, setSelectedTournament] = useState(null);
  const [position, setPosition] = useState('');
  const [minLevel, setMinLevel] = useState('');
  const [message, setMessage] = useState('');
  const [diffusion, setDiffusion] = useState('standard');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [step] = useState(1);

  useEffect(() => {
    axios.get(`${API_URL}/api/tournaments/search?limit=10`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(res => {
      const data = Array.isArray(res.data) ? res.data : res.data.tournaments || [];
      const upcoming = data.filter(item => item.myTeam || item.tournament).slice(0, 6);
      setMyTournaments(upcoming);
    })
    .catch(() => {});
  }, [token]);

  const handleSubmit = async () => {
    if (!selectedTournament) { setError('Sélectionne un tournoi.'); return; }
    setLoading(true); setError('');
    try {
      await axios.post(`${API_URL}/api/partner-searches`, {
        tournamentId: selectedTournament.tournament?.id || selectedTournament.id,
        position: position || null,
        minLevel: minLevel || null,
        message: message.trim() || null,
        diffusion,
      }, { headers: { Authorization: `Bearer ${token}` } });
      navigate('/recherche?tab=equipes');
    } catch (err) {
      setError(errorMessage(err, "La publication a échoué. Réessaie dans un instant."));
    } finally { setLoading(false); }
  };


  return (
    <div className="screen" style={{ background: 'var(--ink)', minHeight: '100vh' }}>
      <div style={{ height: 54 }} />

      {/* Header */}
      <div style={{ padding: '4px 20px 12px', flexShrink: 0, borderBottom: '1px solid var(--line)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <button aria-label="Retour" onClick={() => navigate(-1)} style={{
            width: 36, height: 36, borderRadius: '50%', background: 'var(--ink-3)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            border: 'none', cursor: 'pointer', color: 'var(--text)',
          }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M11 6l-6 6 6 6"/>
            </svg>
          </button>
          <div className="display" style={{ fontSize: 18 }}>Recherche de partenaire</div>
          <button onClick={() => navigate(-1)} style={{
            fontSize: 13, fontWeight: 600, color: 'var(--text-3)',
            background: 'none', border: 'none', cursor: 'pointer',
          }}>Annuler</button>
        </div>
      </div>

      <div style={{ overflowY: 'auto', paddingBottom: 120 }}>

        {error && (
          <div style={{ margin: '16px 20px 0', padding: '10px 14px', borderRadius: 10,
            background: 'rgba(229,80,62,0.1)', color: '#E5503E',
            fontSize: 13, fontWeight: 600, border: '1px solid rgba(229,80,62,0.25)' }}>
            {error}
          </div>
        )}

        {/* Step 1 — Tournoi */}
        <SectionTitle right={`${step}/3`}>1. Pour quel tournoi ?</SectionTitle>
        <div style={{ padding: '0 20px', display: 'flex', flexDirection: 'column', gap: 10 }}>
          {myTournaments.length === 0 ? (
            <div className="card" style={{ padding: 16, textAlign: 'center' }}>
              <div style={{ fontSize: 13, color: 'var(--text-3)', marginBottom: 12 }}>
                Aucun tournoi à venir. Rejoins ou crée un tournoi d'abord.
              </div>
              <button onClick={() => navigate('/recherche')} className="btn btn-primary btn-sm">
                Trouver un tournoi
              </button>
            </div>
          ) : (
            myTournaments.map(item => {
              const t = item.tournament || item;
              const isSelected = selectedTournament?.tournament?.id === t.id || selectedTournament?.id === t.id;
              const dateStr = t.date
                ? new Date(t.date + 'T12:00').toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' })
                : '';
              const photoClass = surfaceToPhoto(t.surface);
              return (
                <button key={t.id} type="button" onClick={() => setSelectedTournament(item)}
                  className="tourney-hero on-hero"
                  style={{
                    position: 'relative', isolation: 'isolate', overflow: 'hidden',
                    borderRadius: 'var(--r-md)', cursor: 'pointer', textAlign: 'left', width: '100%',
                    padding: '14px 16px', minHeight: 72, display: 'flex', alignItems: 'flex-end',
                    border: `2px solid ${isSelected ? 'var(--sun)' : 'transparent'}`,
                  }}>
                  <div className={`hero-photo ${photoClass}`} style={{ opacity: 0.8 }} />
                  <div className="hero-tint" />
                  <div style={{ flex: 1, minWidth: 0, position: 'relative', zIndex: 1 }}>
                    <div style={{ fontSize: 15, fontWeight: 800, color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontFamily: "'Anton', sans-serif", letterSpacing: '0.02em', textTransform: 'uppercase' }}>{t.name}</div>
                    <div className="mono" style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)', marginTop: 2 }}>
                      {[t.playerFormat, dateStr].filter(Boolean).join(' · ')}
                    </div>
                  </div>
                  {isSelected && (
                    <div style={{ position: 'relative', zIndex: 1, marginLeft: 10, width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
                      background: 'var(--sun)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" strokeWidth="3.5" strokeLinecap="round"><path d="M5 12l5 5 9-11"/></svg>
                    </div>
                  )}
                </button>
              );
            })
          )}
        </div>

        {/* Step 2 — Profil cherché */}
        <SectionTitle>2. Qui tu cherches ?</SectionTitle>
        <div style={{ padding: '0 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          {/* Poste */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--text-3)', marginBottom: 8 }}>Poste</div>
            <div className="card" style={{ padding: 12 }}>
              <div style={{ display: 'flex', gap: 8 }}>
                {POSITIONS.map(p => (
                  <button key={p.value} type="button" onClick={() => setPosition(p.value)} style={{
                    flex: 1, padding: '10px 0', borderRadius: 8, fontSize: 13, fontWeight: 600,
                    background: position === p.value ? 'var(--text)' : 'var(--ink-3)',
                    color: position === p.value ? 'var(--ink)' : 'var(--text-2)',
                    border: 'none', cursor: 'pointer',
                  }}>{p.label}</button>
                ))}
              </div>
            </div>
          </div>

          {/* Niveau min */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--text-3)', marginBottom: 8 }}>Niveau min.</div>
            <div className="card" style={{ padding: 12 }}>
              <div style={{ display: 'flex', gap: 6 }}>
                {LEVELS.map(l => (
                  <button key={l.value} type="button" onClick={() => setMinLevel(v => v === l.value ? '' : l.value)} style={{
                    flex: 1, minWidth: 0, padding: '10px 0', borderRadius: 8, fontSize: 12, fontWeight: 600,
                    background: minLevel === l.value ? 'var(--sun)' : 'var(--ink-3)',
                    color: minLevel === l.value ? 'var(--ink)' : 'var(--text-2)',
                    border: 'none', cursor: 'pointer',
                  }}>{l.label}</button>
                ))}
              </div>
            </div>
          </div>

          {/* Message */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--text-3)', marginBottom: 8 }}>Message à afficher</div>
            <div className="card" style={{ padding: 14 }}>
              <textarea
                value={message}
                onChange={e => setMessage(e.target.value)}
                placeholder="Esprit relax mais on vient pour gagner. Dispo dès 8h..."
                maxLength={200}
                rows={3}
                style={{
                  width: '100%', background: 'transparent', border: 0, outline: 0, resize: 'none',
                  color: 'var(--text)', fontSize: 14, fontFamily: 'inherit', lineHeight: 1.5,
                  boxSizing: 'border-box',
                }}
              />
              <div className="mono" style={{ textAlign: 'right', fontSize: 10, color: 'var(--text-4)', marginTop: 4 }}>
                {message.length}/200
              </div>
            </div>
          </div>
        </div>

        {/* Step 3 — Diffusion */}
        <SectionTitle>3. Diffusion</SectionTitle>
        <div style={{ padding: '0 20px', display: 'flex', flexDirection: 'column', gap: 10 }}>
          {BOOST_OPTIONS.map(opt => (
            <button key={opt.value} type="button" onClick={() => setDiffusion(opt.value)}
              style={{
                display: 'flex', alignItems: 'center', gap: 14, padding: '16px',
                borderRadius: 'var(--r-md)', border: `1.5px solid ${diffusion === opt.value ? 'var(--sun)' : 'var(--line)'}`,
                background: diffusion === opt.value ? 'rgba(245,166,35,0.06)' : 'var(--ink-2)',
                cursor: 'pointer', textAlign: 'left', width: '100%',
              }}>
              <div style={{
                width: 20, height: 20, borderRadius: '50%', flexShrink: 0,
                border: `2px solid ${diffusion === opt.value ? 'var(--sun)' : 'var(--line)'}`,
                background: diffusion === opt.value ? 'var(--sun)' : 'transparent',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {diffusion === opt.value && <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="var(--ink)" strokeWidth="3.5" strokeLinecap="round"><path d="M5 12l5 5 9-11"/></svg>}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text)', marginBottom: 2 }}>{opt.label}</div>
                <div style={{ fontSize: 12, color: 'var(--text-3)' }}>{opt.sublabel}</div>
              </div>
              <span style={{
                padding: '4px 10px', borderRadius: 999, fontSize: 11, fontWeight: 700,
                background: opt.value === 'boost' ? 'rgba(245,166,35,0.18)' : 'var(--ink-3)',
                color: opt.value === 'boost' ? 'var(--sun-2)' : 'var(--text-3)',
              }}>{opt.badge}</span>
            </button>
          ))}
        </div>

      </div>

      {/* Fixed CTA */}
      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0,
        padding: '12px 20px 28px',
        background: 'linear-gradient(to top, var(--ink) 70%, transparent)',
      }}>
        <button
          onClick={handleSubmit}
          disabled={loading || !selectedTournament}
          className="btn btn-primary"
          style={{ width: '100%', padding: '15px 20px' }}>
          {loading ? 'Publication en cours…' : 'Publier la recherche'}
        </button>
      </div>
    </div>
  );
}
